import Dashboard3 from "../../core/Dashboard3"


const StudentDashboard = () => {
  return (
    <>
      <Dashboard3 />
    </>
  )
}

export default StudentDashboard